import { createFragmentContainer, graphql } from 'react-relay';
import ContractTemplateComponent from './ContractTemplateComponent';

export default createFragmentContainer(ContractTemplateComponent, {
  node: graphql`
    fragment ContractTemplateContainer_node on CTemplate {
      id
      title
      terms
      brand {
        id
        logo_url
        header
      }
      c_template_line_items(first: 99999)
        @connection(key: "ContractTemplateContainer_c_template_line_items") {
        edges {
          node {
            id
            description
            position
            price_cents
            price_currency
            quantity
            title
          }
        }
      }
      c_template_signature_blocks(first: 99999)
        @connection(key: "ContractTemplateContainer_c_template_signature_blocks") {
        edges {
          node {
            id
            address_visibility
            company_name_visibility
            email_visibility
            name_visibility
            phone_visibility
            signing_party
            title_visibility
          }
        }
      }
    }
  `,
  viewer: graphql`
    fragment ContractTemplateContainer_viewer on User {
      id
      first_name
      last_name
      primary_brand {
        id
      }
      ...SearchContainer_viewer
      ...LibraryContainer_viewer
    }
  `
});



// WEBPACK FOOTER //
// ./webpack/components/Document/Template/Contract/ContractTemplateContainer.js